import React from 'react';
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {service as SurveyQuestionDataTypeService} from "../../../Services/SurveyQuestionDataTypeService";
import {SurveyFormInputComponentsBySurveyQuestionDataType} from "./Inputs/SurveyFormInputComponentsBySurveyQuestionDataType";

export function SurveyFormInput(props) {
    
    const {
        Question
    } = props;
    
    if(!usePrimeCache(SurveyQuestionDataTypeService)) {
        return null;
    }
    
    const dataType = (SurveyQuestionDataTypeService.CachedValueById(Question?.surveyQuestionDataTypeId)?.result);
    const DynamicComponent = SurveyFormInputComponentsBySurveyQuestionDataType[dataType?.code] ?? null;
    
    if(typeof DynamicComponent === 'string') {
        return DynamicComponent; // this is a label, so just return the string.
    }
    
    if(!DynamicComponent) {
        console.log(`No defined Component for DataType ${dataType?.code}.`, Question);
        return null;
    }
    
    return <DynamicComponent
        {...props}
        SurveyQuestionDataType={dataType}
    />;
}


